import { RQ } from 'utils';

export default {
  getTipInfo: async function () {
    if (G.member && G.member.token) {
      const res = await RQ.mall.get('/api/h5/user/member/tips', {}, { skipAuth: true });
      if (res && res.code == 0) {
        this.tipInfo = res.data;
      } else {
        this.tips(res.msg, 1500);
      }
    }
  },
  goBack: function () {
    console.log('-------0');
    this.$router.go(-1);
  },
  downLoadApp: async function () {
    if (this.enterprise) {
      this.$router.push({ path: `/download?enterprise=${this.enterpriseNo}` });
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/vip/paySuccess/action.js